// The words fire's controllers say, in the page's language. fire_head_tags
// writes them into <meta name="fire-text">; read on every call, so a Turbo
// visit that swaps the head swaps the language too.
//
//   say('copied')             → "Copiado!"
//   say('scanner.qr.valid')   → "Código válido!"
export function say(path) {
  const meta = document.querySelector('meta[name="fire-text"]');
  const all = meta ? JSON.parse(meta.content) : {};
  return path.split('.').reduce((node, key) => node?.[key], all) ?? '';
}

// Somebody's record into markup: the five characters that break out of text
// or a quoted attribute. Every `innerHTML` and `setHTML` in fire goes through it.
export const esc = (text) =>
  String(text ?? '').replace(
    /[&<>"']/g,
    (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c],
  );
